import { generatePath } from 'react-router-dom';
import { Country } from '@tiendanube/common/src/enums';
import ShowByCountry from 'App/components/ShowByCountry';
import { NUVEMENVIO_CYBER_MONDAY_RATE_BANNER } from 'App/featuresFlags';
import { useNavegate } from 'App/hooks';
import { useResponsive } from 'commons/components';
import { useDismissibleComponent } from 'commons/hooks';
import { useGetTags } from 'domains/Auth/hooks';
import {
  trackingNuvemEnvioCyberMondayRateBannerClick,
  trackingNuvemEnvioCyberMondayRateBannerClose,
} from 'domains/NuvemEnvioCommons/tracking';
import { PARTNER_APPS_ROUTES } from 'domains/PartnersApps/partnersAppsRoutes';
import BannerDesktop from '../BannerDesktop';
import BannerMobile from '../BannerMobile';

function CyberMondayRateBanner() {
  const { isMobile: isMobileResponsive } = useResponsive();
  const { goTo } = useNavegate();

  const hasCyberMondayRateBanner = useGetTags().includes(
    NUVEMENVIO_CYBER_MONDAY_RATE_BANNER,
  );

  const { shouldShow, dismiss } = useDismissibleComponent(
    'cyber-monday-rate-banner-dismiss',
    90,
  );

  const handleClick = () => {
    trackingNuvemEnvioCyberMondayRateBannerClick();
    goTo(generatePath(`${PARTNER_APPS_ROUTES.envionubear}#/landing-page`));
  };

  const handleClose = () => {
    trackingNuvemEnvioCyberMondayRateBannerClose();
    dismiss();
  };

  if (!shouldShow || !hasCyberMondayRateBanner) {
    return null;
  }

  return (
    <ShowByCountry allowedCountries={[Country.AR]}>
      <>
        {isMobileResponsive && (
          <BannerMobile
            onClose={handleClose}
            onClick={handleClick}
            translateKey="cyberMondayRateBanner"
          />
        )}
        {!isMobileResponsive && (
          <BannerDesktop
            onClose={handleClose}
            onClick={handleClick}
            translateKey="cyberMondayRateBanner"
          />
        )}
      </>
    </ShowByCountry>
  );
}

export default CyberMondayRateBanner;
